import { htmlParse } from "@unisearch/helpers";
import React, { Fragment } from "react";
import { hexToRGB } from "@unisearch/helpers";
import { Grid } from "@mui/material";
import styles from "./contact_info.module.scss";

const LeadSectionContactInfo = ({ pageData }) => {
  return (
    <Fragment>
      {pageData?.pageContent?.featuresSection?.length > 0 ? (
        <Fragment>
          {pageData?.pageContent?.featuresSection?.map((secData, i) => {
            return (
              <section className={styles.section_info} key={i}>
                <div className="container">
                  <div className={styles.wrapper}>
                    <div className={styles.title_wrapper}>
                      <div className={styles.title}>
                        <>
                          {secData?.featureTitle
                            ? htmlParse(secData?.featureTitle)
                            : ""}
                        </>
                      </div>
                      {secData?.featureSubtitle && (
                        <p>{secData?.featureSubtitle}</p>
                      )}
                    </div>

                    <div className={styles.card_section}>
                      {secData?.featuresCard?.length > 0 && (
                        <Grid
                          container
                          spacing={{ xs: 3, sm: 3, md: 4 }}
                          justifyContent="center"
                        >
                          {secData.featuresCard?.map((item, i) => {
                            return (
                              <Grid item xs={12} sm={6} md={4} key={i}>
                                <div className={`${styles.test_card}`}>
                                  {item?.cardIconSrc && (
                                    <div className={styles.test_icon}>
                                      <img src={item?.cardIconSrc} />
                                    </div>
                                  )}
                                  {item?.cardTitle && (
                                    <div className={styles.test_title}>
                                      {item?.cardTitle}
                                    </div>
                                  )}
                                  {item?.cardDescription && (
                                    <div className={styles.test_desc}>
                                      {item?.cardDescription
                                        ? htmlParse(item?.cardDescription)
                                        : ""}
                                    </div>
                                  )}
                                </div>
                              </Grid>
                            );
                          })}
                        </Grid>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            );
          })}
        </Fragment>
      ) : (
        <></>
      )}
    </Fragment>
  );
};

export default LeadSectionContactInfo;
